import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/index.js';
import { NotificationBell } from './notification-bell.js';
import { Logo } from './logo.js';
import { useTheme } from './theme-provider.js';
import { Button } from './button.js';
import { AppMenu } from './app-menu.js';

function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const cycle = () => {
    const next: Record<string, 'dark' | 'light' | 'auto'> = { auto: 'dark', dark: 'light', light: 'auto' };
    setTheme(next[theme]);
  };
  return (
    <Button variant="icon" onClick={cycle} title={`Theme: ${theme}`} aria-label="Toggle theme">
      {resolvedTheme === 'dark' ? (
        <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
          <circle cx="12" cy="12" r="5"/><path strokeLinecap="round" d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
        </svg>
      ) : (
        <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
          <path strokeLinecap="round" d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>
        </svg>
      )}
    </Button>
  );
}

export function Header() {
  const { user, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <header className="site-header sticky top-0 z-50 flex items-center justify-between px-7">
        <div className="flex items-center gap-8">
          {/* Mobile hamburger */}
          <button
            type="button"
            style={{ color: 'var(--color-text-2)' }}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? 'Close the menu' : 'Open the menu'}
            aria-expanded={mobileMenuOpen}
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              )}
            </svg>
          </button>
          <Link to="/" style={{ textDecoration: 'none' }} onClick={() => setMobileMenuOpen(false)}>
            <Logo />
          </Link>
        </div>
        <div className="flex items-center gap-3">
          <ThemeToggle />
          <NotificationBell />
          {user && (
            <div className="user-chip" onClick={logout}>
              <div className="user-avatar">
                {(user.email ?? user.sub ?? '??').substring(0, 2).toUpperCase()}
              </div>
              <span className="hidden md:block">{user.email ?? user.sub}</span>
            </div>
          )}
        </div>
      </header>

      {/* The same menu as the sidebar's: the server shown, what waits on you there, its pages, then every server's */}
      {mobileMenuOpen && (
        <div className="menu-panel sticky top-14 z-40">
          <AppMenu onNavigate={() => setMobileMenuOpen(false)} />
        </div>
      )}
    </>
  );
}
